
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3.719l-.625.5-9 7L4 11.5v1.625l.844.125 5 .75H13v8h2v-8h3.156l5-.813.844-.124V11.5l-.375-.281-9-7zm0 4.125L15.563 12h-3.126zm-2.188.093L10.313 12h-.156l-2.969-.438zm4.376.032l4.593 3.562-2.937.469h-.157zm10.343 9.156L15.75 23H4v2h2v3h2v-3h16v3h2v-3h2v-2h-2.219l-.718-2.813 2.406-1.312zm-3.281 4.031L23.719 23h-3.813z"}})])
          )
        }
      }
    